import { PlayerName } from "../../PlayerName";
import { ScoreResult } from "../../ScoreResult";
import { trophyIconsMap } from "./TableRowHelper";
import styles from "../styles.module.css";
import { BPLeaderboardItem } from "../../../api/interfaces/BPleaderboard-item.interface";
import { ScoreMarkEnum } from "../../../api/enums/leaderboard-enums";

export interface IMakeRowProps {
  item?: BPLeaderboardItem | null;
  marks: ScoreMarkEnum[];
  index: number;
}

export function MakeRow({ item, marks, index }: IMakeRowProps) {
  const getRankImage = (index: number) => {
    if (trophyIconsMap[index]) {
      return (
        <div className={styles.iconTrophyWrapper}>
          <img
            className={styles.iconTrophy}
            alt={`Trophy icon ${index + 1} place`}
            src={trophyIconsMap[index]}
          />
        </div>
      );
    } else return <div>{index + 1}</div>;
  };

  return (
    <div className={styles.leaderboardRowWrapper}>
      <div className={styles.rank}>{getRankImage(index)}</div>
      <div
        className={`${styles.leaderboardRow} ${
          !item ? styles.leaderboardEmptyRow : ""
        }`}
      >
        <PlayerName name={item ? item.name : ""} />
        <ScoreResult
          marks={marks}
          item={item}
          emptyString={!item ? "-" : undefined}
        />
      </div>
    </div>
  );
}
